import TOPGAIN_EXT_1 from "./TOPGAIN_EXT_1";
export default {
  TOPGAIN_EXT_1,
};
